import { useCallback } from 'react';
import { useFlagService } from '@atlassian/jira-flags';
import { useIntl } from '@atlassian/jira-intl';
import { messages } from './messages.tsx';

export const useFormSelectedErrorFlag = () => {
	const { showFlag } = useFlagService();
	const { formatMessage } = useIntl();

	const showFormSelectFailFlag = useCallback(() => {
		showFlag({
			id: 'proforma-template-library.ui.library.form-selected-error',
			type: 'error',
			title: formatMessage(messages.title),
			isAutoDismiss: true,
		});
	}, [showFlag, formatMessage]);

	return {
		showFormSelectFailFlag,
	};
};
